import Converter from './Converter';
import { shortLanguages } from 'services/locale';
import { CasinoType, ICasinoProviderConfigurationItem } from 'modules/Casino/types/configuration';
import { projectName } from 'modules/Casino/utils/slots';
import { parseCookies } from '../../utils/parseCookies';
import { QueryTypes } from 'modules/Casino/types/enums/api';

const converter = new Converter();

export const config: ICasinoProviderConfigurationItem<Converter> = {
  type: CasinoType.slots,
  multiProvider: true,
  platform: ['mobile', 'desktop'],
  gameListUrl: `slotegrator/games/list?project_name=${projectName}`,
  converter,
  liveGamesProviders: ['vivogaming'],
  sessionUrlData: {
    url: `slotegrator/games/link`,
    getQuery: params =>
      `?project_name=${projectName}${params.isDesktop ? '' : `&return_url=${location.origin}`}&game_uuid=${
        params.gameId
      }&language=${params.lang}${params.isCurrencySubstitute ? '&is_currency_substitute=true' : ''}`,
    getHeaders: () => ({ headers: { Authorization: parseCookies() } }),
    method: QueryTypes.GET,
    converter: converter.convertGameUrl,
  },
};
